<mat-toolbar class="action-toolbar green">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back"><mat-icon>arrow_back_ios</mat-icon></button>
    <h3>{{ patient | patientHeading:'Discharge':'Discharge Patient' }}</h3>
    <div>
        <button mat-icon-button [disabled]="form.invalid" (click)="dischargePatient()"
            matTooltip="Discharge Patient"><mat-icon>save</mat-icon></button>
    </div>
</mat-toolbar>

<div class="discharge-details-container">
    <form [formGroup]="form">
        <mat-card class="m-b-10">

            <mat-form-field appearance="outline">
                <mat-label>Discharge Date</mat-label>
                <input matInput [matDatepicker]="dischargeDatePicker" formControlName="dischargeDate"
                    placeholder="DD/MM/YYYY" [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="dischargeDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dischargeDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width" id="details">
                <mat-label>Discharge Summary</mat-label>
                <textarea matInput cdkTextareaAutosize="false" rows="20" formControlName="dischargeSummary"
                    #dischargeSummaryTextarea></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="form.get('dischargeSummary')?.value" class="full-width">
                <textarea matInput placeholder="Instruct MedicAI" cdkTextareaAutosize="true" rows="1"
                    #dischargeSummaryAutosize="cdkTextareaAutosize" formControlName="dischargeSummaryPrompt"
                    (keydown.enter)="aiPerformUserPrompt($event, 'dischargeSummary')"></textarea>
                <button matSuffix mat-icon-button (click)="aiPerformUserPrompt(null, 'dischargeSummary')">
                    <mat-icon>send</mat-icon>
                </button>
                <mat-hint>
                    Customize your output
                    <mat-icon
                        matTooltip="You can say things like, output as paragraphs, or add additional information to X heading.">info</mat-icon>
                </mat-hint>
            </mat-form-field>

            <div class="actions" *ngIf="form.get('dischargeSummary')?.value">

                <ng-container *ngIf="canSign; else cantSign">
                    <button mat-raised-button color="secondary" matTooltip="Download discharge summary as PDF"
                        [matMenuTriggerFor]="downloadMenu">
                        <mat-icon>file_download</mat-icon> Download PDF
                    </button>

                    <!--Will trigger a menu bar asking if you want to attach doctors signature -->
                    <mat-menu #downloadMenu="matMenu" class="p-10">
                        <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnPdf" class="checkbox"
                            (click)="$event.stopPropagation()">
                            {{isPhysician ?'Attach Signature' : 'Attach Doctor\'s Signature'}}
                        </mat-checkbox>
                        <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Select Doctor's Signature</mat-label>
                            <mat-select formControlName="selectedDoctor">
                                <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                    {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Document Date</mat-label>
                            <input matInput [matDatepicker]="pdfDatePicker" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="pdfDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #pdfDatePicker></mat-datepicker>
                        </mat-form-field>

                        <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('doctor')">
                            Download PDF <mat-icon>file_download</mat-icon>
                        </button>
                    </mat-menu>
                </ng-container>
                <ng-template #cantSign>
                    <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('doctor')">
                        Download PDF <mat-icon>file_download</mat-icon>
                    </button>
                </ng-template>

                <button mat-icon-button color="primary" 
                    *ngIf="form.get('dischargeSummary')?.value"
                    appWhatsappDialogTrigger 
                    [patientId]="patient?.id" 
                    [patient]="patient"
                    [initialMessage]="getDischargeSummaryPlainText()"
                    matTooltip="Send this discharge summary via WhatsApp">
                    <mat-icon svgIcon="whatsapp"></mat-icon>
                </button>
                <button mat-raised-button color="primary" matTooltip="Send this discharge summary via email" *ngIf="!stateUnit"
                    [matMenuTriggerFor]="emailMenu">
                    <mat-icon>mail</mat-icon> Send Summary
                </button>
                <mat-menu #emailMenu="matMenu" class="p-10">
                    <div mat-menu-content (click)="$event.stopPropagation()">
                        <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnEmail" class="checkbox"
                            (click)="$event.stopPropagation()">
                            {{isPhysician ?'Attach Signature' : 'Attach Doctor\'s Signature'}}
                        </mat-checkbox>
                        <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Select Doctor's Signature</mat-label>
                            <mat-select formControlName="selectedDoctor">
                                <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                    {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Document Date</mat-label>
                            <input matInput [matDatepicker]="pdfDatePicker_email1" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="pdfDatePicker_email1"></mat-datepicker-toggle>
                            <mat-datepicker #pdfDatePicker_email1></mat-datepicker>
                        </mat-form-field>
                        <button mat-raised-button color="primary" class="full-width"
                            (click)="sendDischargeSummary('doctor')" matTooltip="Send this discharge summary via email">
                            <mat-icon>send</mat-icon> Send Email
                        </button>
                    </div>
                </mat-menu>
            </div>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Patient Summary</mat-label>
                <textarea matInput cdkTextareaAutosize="false" rows="20" formControlName="patientDischargeSummary"
                    #patientDischargeSummaryTextarea></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="form.get('patientDischargeSummary')?.value" class="full-width">
                <textarea matInput placeholder="Instruct MedicAI" cdkTextareaAutosize="true" rows="1"
                    #patientDischargeSummaryAutosize="cdkTextareaAutosize"
                    formControlName="patientDischargeSummaryPrompt"
                    (keydown.enter)="aiPerformUserPrompt($event, 'patientDischargeSummary')"></textarea>
                <button matSuffix mat-icon-button (click)="aiPerformUserPrompt(null, 'patientDischargeSummary')">
                    <mat-icon>send</mat-icon>
                </button>
                <mat-hint>
                    Customize your output
                    <mat-icon
                        matTooltip="You can say things like, output as paragraphs, or add additional information to X heading.">info</mat-icon>
                </mat-hint>
            </mat-form-field>

            <div class="actions" *ngIf="form.get('patientDischargeSummary')?.value">

                <ng-container *ngIf="canSign; else cantSign">
                    <button mat-raised-button color="secondary" [matMenuTriggerFor]="downloadMenu">
                        <mat-icon>file_download</mat-icon> Download PDF
                    </button>
                    <mat-menu #downloadMenu="matMenu" class="p-10">
                        <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnPdf" class="checkbox"
                            (click)="$event.stopPropagation()">
                            {{isPhysician ? 'Attach Signature' : 'Attach Doctor\'s Signature'}}
                        </mat-checkbox>
                        <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Select Doctor's Signature</mat-label>
                            <mat-select formControlName="selectedDoctor">
                                <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                    {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Document Date</mat-label>
                            <input matInput [matDatepicker]="pdfDatePicker2" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="pdfDatePicker2"></mat-datepicker-toggle>
                            <mat-datepicker #pdfDatePicker2></mat-datepicker>
                        </mat-form-field>
                        <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('patient')">
                            Download PDF <mat-icon>file_download</mat-icon>
                        </button>
                    </mat-menu>
                </ng-container>
                <ng-template #cantSign>
                    <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('patient')">
                        Download PDF <mat-icon>file_download</mat-icon>
                    </button>
                </ng-template>

                <button mat-icon-button color="primary" 
                    *ngIf="form.get('patientDischargeSummary')?.value"
                    appWhatsappDialogTrigger 
                    [patientId]="patient?.id" 
                    [patient]="patient"
                    [initialMessage]="getPatientDischargeSummaryPlainText()"
                    matTooltip="Send this patient summary via WhatsApp">
                    <mat-icon svgIcon="whatsapp"></mat-icon>
                </button>
                <button mat-raised-button color="primary" matTooltip="Send this discharge summary via email" *ngIf="!stateUnit"
                    [matMenuTriggerFor]="emailMenu">
                    <mat-icon>mail</mat-icon> Send Summary
                </button>
                <mat-menu #emailMenu="matMenu" class="p-10 email-menu-panel">
                    <div mat-menu-content (click)="$event.stopPropagation()">
                        <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnPdf" class="checkbox"
                            (click)="$event.stopPropagation()">
                            {{isPhysician ?'Attach Signature' : 'Attach Doctor\'s Signature'}}
                        </mat-checkbox>
                        <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Select Doctor's Signature</mat-label>
                            <mat-select formControlName="selectedDoctor">
                                <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                    {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <app-recipient-search [patient]="patient" label="Quick Select Recipient"
                            placeholder="Search for recipient..." (recipientSelected)="onRecipientSelected($event)">
                        </app-recipient-search>
                        <mat-form-field appearance="outline" class="full-width" (keydown)="handleMenuKeydown($event)">
                            <mat-label>Recipient Name</mat-label>
                            <input matInput formControlName="name">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Recipient Email</mat-label>
                            <input matInput formControlName="email">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Document Date</mat-label>
                            <input matInput [matDatepicker]="pdfDatePicker_email2" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="pdfDatePicker_email2"></mat-datepicker-toggle>
                            <mat-datepicker #pdfDatePicker_email2></mat-datepicker>
                        </mat-form-field>
                        <button mat-raised-button color="primary" class="full-width"
                            [disabled]="!form.get('email')?.value || form.get('email')?.invalid"
                            (click)="sendDischargeSummary('patient')"
                            matTooltip="Send this discharge summary via email">
                            <mat-icon>send</mat-icon> Send Email
                        </button>
                    </div>
                </mat-menu>
            </div>

            <div class="actions">
                <ng-container>
                    <button mat-raised-button class="ai-feature" (click)="aiGenerateDischargeSummary()"
                        matTooltip="Generate a discharge summary using MedicAI">
                        <mat-icon svgIcon="medic_ai"></mat-icon> {{
                        form.get('dischargeSummary')?.value ? 'Regenerate' : 'Generate'}}
                    </button>
                </ng-container>
            </div>
        </mat-card>

        <mat-expansion-panel [expanded]="false" class="m-t-10">
            <mat-expansion-panel-header>
                <mat-panel-title>FILE UPDATE</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="field-with-action">
                <mat-form-field appearance="outline">
                    <mat-label>Diagnosis/Active Problem</mat-label>
                    <textarea matInput cdkTextareaAutosize="true" formControlName="diagnosis"></textarea>
                </mat-form-field>
                <button mat-icon-button matTooltip="Add additional diagnosis" (click)="addDiagnosisField()"
                    *ngIf="visibleDiagnosisFields.length <= 24" color="primary"><mat-icon>add</mat-icon></button>
            </div>

            <ng-container *ngFor="let field of visibleDiagnosisFields; let i = index">
                <mat-form-field appearance="outline">
                    <mat-label>Diagnosis/Active Problem {{ i + 2 }}</mat-label>
                    <textarea matInput cdkTextareaAutosize="true" [formControlName]="field"></textarea>
                </mat-form-field>
            </ng-container>

            <app-icd-code-selector [patientSex]="icdCodingSex" [patientAge]="icdCodingAge" [defaultOnsetDate]="icdDefaultOnsetDate" [initialCodes]="selectedIcdCodes" (codesChanged)="onIcdCodesChanged($event)"
                [isRequired]="true"></app-icd-code-selector>

            <app-allergy-list-creator [allergies]="selectedAllergies" [noAllergies]="noAllergies"
                (allergiesChanged)="onAllergiesChanged($event)"
                (noAllergiesChanged)="onNoAllergiesChanged($event)"></app-allergy-list-creator>

            <app-medical-history-list-creator [history]="selectedMedicalHistory" [noHistory]="noMedicalHistory"
                (historyChanged)="onMedicalHistoryChanged($event)"
                (noHistoryChanged)="onNoMedicalHistoryChanged($event)">
            </app-medical-history-list-creator>

            <app-medication-list-creator [medications]="selectedMedicationHistory" [noMedication]="noMedicationHistory"
                (medicationChanged)="onMedicationHistoryChanged($event)"
                (noMedicationChanged)="onNoMedicationHistoryChanged($event)">
            </app-medication-list-creator>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" class="m-t-10">
            <mat-expansion-panel-header>
                <mat-panel-title>MEDICATION</mat-panel-title>
            </mat-expansion-panel-header>


            <div class="icd-container">
                <app-medication-autocomplete [patient]="patient" #medicationAutocomplete></app-medication-autocomplete>

                <div class="actions m-t-10" *ngIf="medicationAutocomplete.medicationList.length">

                    <button mat-raised-button [disabled]="!medicationAutocomplete?.isValid()" color="secondary"
                        (click)="savePrescription()">
                        <mat-icon>save</mat-icon> Save Prescription </button>

                    <button mat-raised-button color="primary" matTooltip="Send this prescription via email" *ngIf="!stateUnit"
                        [matMenuTriggerFor]="emailMenu" [disabled]="!medicationAutocomplete?.isValid()">
                        <mat-icon>mail</mat-icon> Send Prescription
                    </button>
                    <mat-menu #emailMenu="matMenu" class="p-10">
                        <div mat-menu-content (click)="$event.stopPropagation()">

                            <!-- I wonder if it needs the checkbox and signature binding -->
                            <mat-form-field appearance="outline" class="full-width"
                                (keydown)="handleMenuKeydown($event)">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>CC Email</mat-label>
                                <input matInput formControlName="ccEmail">
                            </mat-form-field>
                            <button mat-raised-button color="primary" class="full-width"
                                [disabled]="!form.get('email')?.value || form.get('email')?.invalid"
                                (click)="emailPrescription()" matTooltip="Send to this email address">
                                <mat-icon>send</mat-icon> Send Email
                            </button>

                        </div>
                    </mat-menu>
                </div>
                <div *ngIf="suggestedDischargeMedication?.medication" class="m-t-10">
                    <h4 class="m-t-10">Suggested Medication</h4>
                    <mat-list class="full-width">
                        <mat-list-item class="auto-height"
                            *ngFor="let suggestion of suggestedDischargeMedication?.medication">
                            <div class="icd-item">
                                <div class="icd-details">
                                    <p matLine class="icd-title">{{suggestion.item.name}}</p>
                                    <p matLine class="icd-score">Relevance: {{suggestion.score}}%</p>
                                </div>
                                <div class="view-icon">
                                    <button mat-icon-button [matTooltip]="suggestion.reason">
                                        <mat-icon>info</mat-icon>
                                    </button>
                                    <button mat-icon-button color="primary"
                                        *ngIf="canAddMedication(suggestion.item.name)"
                                        matTooltip="Add this medication to the discharge prescription"
                                        (click)="addMedication($event, suggestion.item)">
                                        <mat-icon>library_add</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </mat-list-item>
                    </mat-list>
                </div>


            </div>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" class="m-t-10">
            <mat-expansion-panel-header>MORBIDITY/MORTALITY</mat-expansion-panel-header>

            <div class="toggle-container">
                <mat-slide-toggle formControlName="isMorbidity" color="primary"
                    (change)="toggleMorbidity($event)">Morbidity</mat-slide-toggle>
                <mat-slide-toggle formControlName="isMortality" color="primary" (change)="toggleMortality($event)"
                    class="m-l-5">Mortality</mat-slide-toggle>
            </div>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Reason</mat-label>
                <mat-select formControlName="mmReason">
                    <mat-option *ngFor="let reason of mmReasons" [value]="reason">
                        {{ reason }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Notes</mat-label>
                <textarea matInput cdkTextareaAutosize="true" rows="10" formControlName="mmNotes"></textarea>
            </mat-form-field>

            <div class="actions">
                <button mat-raised-button class="ai-feature" (click)="aiGenerateMorbidityMortality()"
                    matTooltip="Generate morbidity/mortality details using MedicAI">
                    <mat-icon svgIcon="medic_ai"></mat-icon> Generate
                </button>
            </div>

        </mat-expansion-panel>

        <div class="m-t-10">
            <app-patient-task-list [initialExpanded]="false" [actions]="taskListActions"
                heading="CURRENT TASKS"></app-patient-task-list>
        </div>

        <mat-expansion-panel [expanded]="false" class="m-t-10">
            <mat-expansion-panel-header>
                <mat-panel-title>SUGGESTED TASKS</mat-panel-title>
            </mat-expansion-panel-header>


            <div class="icd-container">

                <mat-list class="full-width">
                    <mat-list-item class="auto-height" *ngFor="let task of suggestedDischargeTasks?.tasks">
                        <div class="icd-item">
                            <div class="icd-details">
                                <p matLine class="icd-title">{{task.task}}</p>
                                <p matLine class="icd-score">Relevance: {{task.score}}%</p>
                            </div>
                            <div class="view-icon">
                                <button mat-icon-button [matTooltip]="task.reason">
                                    <mat-icon>info</mat-icon>
                                </button>
                                <button mat-icon-button color="primary" *ngIf="canAddTask(task.task)"
                                    matTooltip="Add this task to the patient file" (click)="addTask($event, task)">
                                    <mat-icon>library_add</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-list-item>
                </mat-list>
            </div>
        </mat-expansion-panel>
    </form>
</div>

<ng-template #noTasks>
    <p class="grey-text">No tasks found for this patient.</p>
</ng-template>

<ng-template #buildRecipientListDialog>
    <h1 mat-dialog-title>Email Recipients</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <app-bulk-email-list-creator #emailListCreator></app-bulk-email-list-creator>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button [mat-dialog-close]="null">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="emailListCreator.recipientList">Save</button>
    </div>
</ng-template>
